import { AppBar, Toolbar, Typography, Box } from '@mui/material';

function Header() {
  return (
    <AppBar position="static" sx={{ backgroundColor: '#fff', color: '#333' }}>
      <Toolbar>
        <Box sx={{ display: 'flex', alignItems: 'center', flexGrow: 1 }}>
          <img 
            src="/prabhupada-logo.jpg" 
            alt="Srila Prabhupada" 
            style={{ 
              height: '50px',
              marginRight: '15px',
              borderRadius: '25px'
            }}
          />
          <Typography variant="h6" component="div" sx={{ color: '#333' }}>
            Bhaktivedanta Vedic Academy
          </Typography>
        </Box>
      </Toolbar>
    </AppBar>
  );
}

export default Header; 